// Backend hazır olana kadar mock veri döner, hazır olduğunda Api.get/post/put/delete çağrılarına bağlanacak.
let mockAds = [
    {
        id: 1,
        company_id: 1,
        company_name: "Kalt Elektronik",
        position: "Pazarlama MT",
        start_date: "01.11.2025",
        end_date: "12.12.2025",
        responsible_id: null,
        min_gno: 2.5,
        location_type: "onsite",
        quota: 5,
        application_count: 24,
        status: "active",
        faculty_code: null,
        department_code: null,
        class: null,
        content: "Pazarlama ekibimize katılacak, dijital pazarlama süreçlerinde görev alacak bir Co-op öğrencisi arıyoruz.",
        company_description: "2016 yılında kurulan KALT Elektronik, küçük ev aletleri ve dayanıklı tüketim ürünlerinde dünya çapında birçok güçlü markanın distribütörlüğünü yapmaktadır.",
        benefits: "Ücret: görüşmede belirlenecektir\nYemek: var\nServis: var",
        qualifications: "Pazarlama ve dijital trendlere meraklı\nSosyal medya ve dijital reklamcılığa ilgi duyan\nExcel / PowerPoint kullanımında yetkin\nAnalitik düşünme becerisine sahip"
    }
];
let nextId = 2;

const getAll = async (config) => {
    const filter = config?.params?.filter ?? {};
    let rows = [...mockAds];

    if (filter.company_id) {
        rows = rows.filter((row) => String(row.company_id) === String(filter.company_id));
    }
    if (filter.status) {
        rows = rows.filter((row) => row.status === filter.status);
    }
    if (filter.faculty_code) {
        rows = rows.filter((row) => row.faculty_code === filter.faculty_code);
    }
    if (filter.department_code) {
        rows = rows.filter((row) => row.department_code === filter.department_code);
    }
    if (filter.class) {
        rows = rows.filter((row) => row.class === filter.class);
    }

    return Promise.resolve({
        data: {
            data: rows,
            pagination: {
                total: rows.length
            }
        }
    });
};

const get = async (id) => {
    const row = mockAds.find((item) => item.id === Number(id));
    return Promise.resolve({
        data: {
            data: row ?? null
        }
    });
};

const store = async (data) => {
    const row = {...data, id: nextId++, application_count: 0};
    mockAds.push(row);
    return Promise.resolve({
        data: {
            data: row,
            message: "successfully_added"
        }
    });
};

const update = async (id, data) => {
    const index = mockAds.findIndex((item) => item.id === Number(id));
    if (index !== -1) {
        mockAds[index] = {...mockAds[index], ...data};
    }
    return Promise.resolve({
        data: {
            data: mockAds[index],
            message: "successfully_updated"
        }
    });
};

const updateStatus = async (id, status) => {
    const row = mockAds.find((item) => item.id === Number(id));
    if (row) {
        row.status = status;
    }
    return Promise.resolve({
        data: {
            data: row ?? null,
            message: "coop_status_updated_success"
        }
    });
};

const remove = async (id) => {
    mockAds = mockAds.filter((item) => item.id !== Number(id));
    return Promise.resolve({
        data: {
            message: "successfully_deleted"
        }
    });
};

export default {
    getAll,
    get,
    store,
    update,
    updateStatus,
    remove
}
